export enum FamilyCount {
  MAX_ADULT = 2,
  MIN_ADULT = 1,
  MAX_CHILD = 10,
  MIN_CHILD = 1,
}
